module.exports = __webpack_public_path__ + "img/creator.13589958.svg";